import React from "react";
import {NavLink } from "react-router-dom";







class Navbar extends React.Component{

  render(){
   
    return(
        <div>
        {/*<div className="sub-header">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-xs-12">
                <ul className="left-info">
                  <li><a href="tel:+918939897239"><i className="fa fa-phone" />+91-8939897239</a></li>
                  <li><a href="tel:+918939897239"><i className="fa fa-phone" />+91-7299947239</a></li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className="right-icons">
                  {<li><a href="#"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="#"><i class="fa fa-behance"></i></a></li>}
                </ul>
              </div>
            </div>
          </div>
        </div>*/}
        <nav>
        <header className>
          <nav className="navbar navbar-expand-lg">
            <div className="container">
              <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
              <a className="navbar-brand" href="/home"><h2>Lakshan Associates</h2></a>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" />
              </button>
              <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ml-auto">
                <li className="nav-item ">
                    <NavLink to= "/home"
                    exact = {true}
                    activeClassName=" active "
                    className="nav-link" 
                    >Home </NavLink>
                    
                  </li>
                  <li className="nav-item ">
                   <a>
                   <NavLink 
                   exact activeclassName="nav-link active"
                   className="nav-link" to= "/about" >About Us </NavLink> </a>
                  </li>
                  
                  <li className="nav-item">
                    <a className="nav-link" href="/ourservices">Our Services</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/contactus">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
      </header></nav> 
        </div>
    )
  }
}


export default Navbar;